import { createReducer } from '@reduxjs/toolkit';
import { FaqList, GetFaqListParams } from '../../types/Endpoints/faq/FaqContracts';
import { getFaqList } from '../../actions/faq';

interface FaqState {
    faqList?: FaqList;
    lastListParams?: GetFaqListParams;
}

export const faq = createReducer<FaqState>({}, builder => {
    builder.addCase(getFaqList.fulfilled, (state, { payload, meta }) => ({
        ...state,
        faqList: payload,
        lastListParams: meta.arg,
    }));
});
